export default __webpack_public_path__ + "static/book_cover-4b44080a0068ccc028aeae74b5988b29.png";